{
	"cs_CZ": "cs-CZ",
	"cs": "cs-CZ",
	"da_DK": "da-DK",
	"da": "da-DK",
	"de_DE": "de-DE",
	"de": "de-DE",
	"en_GB": "en-GB",
	"en-GB": "en-GB",
	"en_UK": "en-US",
	"en-UK": "en-US",
	"enUS": "enUS",
	"en_US": "en-US",
	"en-US": "en-US",
	"es-ES": "es-ES",
	"es": "es-ES",
	"et_EE": "et-EE",
	"et": "et-EE",
	"fi_FI": "fi-FI",
	"fi": "fi-FI",
	"fr_FR": "fr-FR",
	"fr": "fr-FR",
	"hu_HU": "hu-HU",
	"hu": "hu-HU",
	"is_IS": "is-IS",
	"is": "is-IS",
	"it_IT": "it-IT",
	"it": "it-IT",
	"ja_JP": "ja-JP",
	"ja": "ja-JP",
	"ko_KR": "ko-KR",
	"ko": "ko-KR",
	"nb_NO": "nb-NO",
	"nb": "nb-NO",
	"nl_NL": "nl-NL",
	"nl": "nl-NL",
	"pl_PL": "pl-PL",
	"pl": "pl-PL",
	"pt_BR": "pt-BR",
	"pt-BR": "pt-BR",
	"pt_PT": "pt-PT",
	"pt": "pt-PT",
	"ro_RO": "ro-RO",
	"ro": "ro-RO",
	"ru_RU": "ru-RU",
	"ru": "ru-RU",
	"sk_SK": "sk-SK",
	"sk": "sk-SK",
	"sv_SE": "sv-SE",
	"sv": "sv-SE",
	"tr": "tr-TR",
	"tr_TR": "tr-TR",
	"tr-TR": "tr-TR",
	"zh_CN": "zh-CN",
	"zh-CN": "zh-CN",
	"zh_TW": "zh-TW",
	"zh-TW": "zh-TW"
}
